<template xmlns="http://www.w3.org/1999/html">
  <div class="h-100">
    <div class="timer"
         v-if="setting.timer === true && selectedView === 'session' && poster && poster.presentation_duration">
      <timer :presentationTime="poster.presentation_duration * 60" v-bind:key="poster.abstract_id"></timer>
    </div>
    <div v-if="poster && poster.content" class="text-center h-100" :key="$route.params.id">
      <div class="row bg-primary pt-2 pb-2">
        <div class="col text-start font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
          <div>Abstract ID: {{poster.abstract_id}}</div>
          <span v-html="poster.title"></span>
        </div>
        <div class="col text-start smaller-blank" v-else>{{ poster.presentation_code }} <span
            v-html="poster.title"></span></div>
      </div>
      <div class="row bg-primary font-weight-bold mb-2" v-if="!isMobile()">
        <div class="col col-2 d-flex ">
          <router-link :to="getBackUrl()" class="btn btn-sm mr-auto my-auto">
            <icon :icon="['fal', 'arrow-circle-left']" class="fa-3x"/>
            <div class="my-auto">{{ _.buttons_back }}</div>
          </router-link>
          <router-link class="btn btn-sm" :to="'/viewer/abstract/' + poster.abstract_id"
                       title="Switch to abstract" v-if="setting.abstract === true">
            <icon :icon="['fab', 'wpforms']" class="fa-3x"/>
            <div class="my-auto">{{ _.poster_nav_abstract }}</div>
          </router-link>
          <router-link class="btn btn-sm" :to="'/viewer/video/' + poster.abstract_id"
                       v-if="poster.content.video"
                       title="Switch to abstract">
            <icon :icon="['fal', 'film']" class="fa-3x"/>
            <div class="my-auto">{{ _.card_video }}</div>
          </router-link>
          <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#staticBackdropDownload"
                  v-if="setting.download === true">
            <icon :icon="['fal', 'file-download']" class="fa-3x"/>
            <div>{{ _.poster_nav_download }}</div>
          </button>
        </div>
        <div v-if="isMobile()" class="w-100 d-md-none"></div>
        <div class="col d-flex mx-auto">
          <div class="mx-auto">
            <template v-if="filteredPosters && setting.pageination === true">
              <router-link class="btn btn-sm font-weight-bold" v-if="getPosition() > 0"
                           :to="'/viewer/' + filteredPosters[getPosition() - 1].abstract_id">
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_last }}</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_last }}</div>
              </button>
            </template>
            <template v-if="numPages > 1">
              <button class="btn btn-sm text-white" v-on:click="page = 1" v-if="page > 1" title="First page">
                <icon :icon="['fal', 'angle-double-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-double-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm text-white" v-on:click="page--" v-if="page > 1" title="Previous page">
                <icon :icon="['fal', 'angle-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-left']" class="fa-3x"/>
              </button>
            </template>

            <button class="btn btn-sm font-weight-bold" v-on:click="setScale(scale - 0.1)"
                    title="Zoom out">
              <icon :icon="['fal', 'search-minus']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_out }}</div>
            </button>
            <button class="btn btn-sm font-weight-bold " v-on:click="scale = 'page-width'"
                    title="Zoom reset">
              <icon :icon="['fal', 'search']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_reset }}</div>
            </button>
            <button class="btn btn-sm font-weight-bold " v-on:click="setScale(scale + 0.1)"
                    title="Zoom in">
              <icon :icon="['fal', 'search-plus']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_in }}</div>
            </button>

            <template v-if="numPages > 1">
              <button class="btn btn-sm text-white " v-on:click="page++" v-if="page < numPages" title="Next page">
                <icon :icon="['fal', 'angle-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm text-white" v-on:click="page = numPages" v-if="page < numPages"
                      title="Last page">
                <icon :icon="['fal', 'angle-double-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-double-right']" class="fa-3x"/>
              </button>
            </template>
            <template v-if="filteredPosters && setting.pageination === true">
              <router-link class="btn btn-sm"
                           v-if="filteredPosters.length > getPosition() + 1"
                           :to="'/viewer/' + filteredPosters[getPosition() + 1].abstract_id">
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_next }}</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_next }}</div>
              </button>
            </template>
          </div>
        </div>
        <div class="col" v-if="poster.content.audio">
          <AudioPlayer :file="getAudioUrl(poster.content.audio)" :loop="false" :auto-play="false"></AudioPlayer>
        </div>
        <div class="col col-lg-1 " v-if="setting.comment === true">
          <button class="btn btn-sm position-relative" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasComments"
                  aria-controls="offcanvasComments">
            <icon :icon="['fal', 'comments']" class="fa-3x"/>
            <div class="my-auto">{{ _.poster_nav_comments }}</div>
            <span v-if="commentCount > 0"
                  class="position-absolute top-0 start-75 translate-middle badge rounded-pill bg-white text-primary fw-bold">
              {{ commentCount }}
            </span>
          </button>
        </div>
        <div class="col col-2 col-lg-1 " v-if="setting.contact === true">
          <button class="btn btn-sm pointer-click flex-grow-1"
                  v-on:click="openContact(poster.abstract_id)">
            <icon :icon="['fal', 'message']" class="fa-3x"/>
            <div class="my-auto">&nbsp;{{ _.card_contact }}</div>
          </button>
        </div>
        <div class="col col-lg-2 d-flex " v-if="setting.rating === true">
          <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#staticBackdropRating">
            <icon class="fa-3x" :icon="['fal', 'star']"/>
            <div class="my-auto">&nbsp;Rate now</div>
          </button>
        </div>
      </div>
      <div class="row bg-primary font-weight-bold mb-2" v-else>
        <div class="col d-flex">
          <router-link :to="getBackUrl()" class="btn btn-sm mr-auto my-auto">
            <icon :icon="['fal', 'arrow-circle-left']" class="fa-3x"/>
            <div class="my-auto">Back</div>
          </router-link>
          <button class="btn btn-sm position-relative" type="button" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasAction"
                  aria-controls="staticBackdrop">
            <icon :icon="['fal', 'circle-caret-down']" class="fa-3x"/>
            <div>{{ _.poster_nav_actions }}</div>
            <span v-if="commentCount > 0"
                  class="position-absolute top-0 start-75 translate-middle badge rounded-pill bg-white text-primary fw-bold">
              {{ commentCount }}
            </span>
          </button>
          <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#staticBackdropRating"
                  v-if="setting.rating === true">
            <icon class="fa-3x" :icon="['fal', 'star']"/>
            <div class="my-auto">&nbsp;Rate now</div>
          </button>
        </div>
        <div class="w-100 d-md-none"></div>
        <div v-if="isMobile()" class="w-100 d-md-none"></div>
        <div class="col d-flex mx-auto">
          <div class="mx-auto">
            <template v-if="filteredPosters && setting.pageination === true">
              <router-link class="btn btn-sm font-weight-bold" v-if="getPosition() > 0"
                           :to="'/viewer/' + filteredPosters[getPosition() - 1].abstract_id">
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_last }}</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-left']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_last }}</div>
              </button>
            </template>
            <template v-if="numPages > 1">
              <button class="btn btn-sm text-white" v-on:click="page = 1" v-if="page > 1" title="First page">
                <icon :icon="['fal', 'angle-double-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-double-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm text-white" v-on:click="page--" v-if="page > 1" title="Previous page">
                <icon :icon="['fal', 'angle-left']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-left']" class="fa-3x"/>
              </button>
            </template>

            <button class="btn btn-sm font-weight-bold" v-on:click="setScale(scale - 0.1)"
                    title="Zoom out">
              <icon :icon="['fal', 'search-minus']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_out }}</div>
            </button>
            <button class="btn btn-sm font-weight-bold " v-on:click="scale = 'page-width'"
                    title="Zoom reset">
              <icon :icon="['fal', 'search']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_reset }}</div>
            </button>
            <button class="btn btn-sm font-weight-bold " v-on:click="setScale(scale + 0.1)"
                    title="Zoom in">
              <icon :icon="['fal', 'search-plus']" class="fa-3x"/>
              <div class="my-auto">{{ _.poster_nav_zoom_in }}</div>
            </button>

            <template v-if="numPages > 1">
              <button class="btn btn-sm text-white " v-on:click="page++" v-if="page < numPages" title="Next page">
                <icon :icon="['fal', 'angle-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm text-white" v-on:click="page = numPages" v-if="page < numPages"
                      title="Last page">
                <icon :icon="['fal', 'angle-double-right']" class="fa-3x"/>
              </button>
              <button class="btn btn-sm disabled" disabled v-else>
                <icon :icon="['fal', 'angle-double-right']" class="fa-3x"/>
              </button>
            </template>
            <template v-if="filteredPosters && setting.pageination === true">
              <router-link class="btn btn-sm font-weight-bold"
                           v-if="filteredPosters.length > getPosition() + 1"
                           :to="'/viewer/' + filteredPosters[getPosition() + 1].abstract_id">
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_next }}</div>
              </router-link>
              <button class="btn btn-sm border-0 font-weight-bold disabled" v-else>
                <icon :icon="['fal', 'arrow-right']" class="fa-3x"/>
                <div class="my-auto">{{ _.poster_nav_next }}</div>
              </button>
            </template>
          </div>
        </div>
      </div>
      <div class="row mb-2" v-if="isMobile() && setting.audio">
        <div class="col">
          <AudioPlayer :file="getAudioUrl(poster.content.audio)" :loop="false" :auto-play="false"></AudioPlayer>
        </div>
      </div>

      <div class="row w-100" @click="placeLaserPointer($event)"
           @touchstart="placeLaserPointer($event)">
        <!--<div class="col-1 col-xl-1"></div>-->
        <div class="col border d-flex w-100" v-if="poster && poster.content">
          <pdf :src="pdfdata" :key="page" :id="page" :page="page" :scale.sync="scale" :resize="false"
               style="width:100%;" class="mx-auto">

          </pdf>
          <!--TODO: Wieder einbauen irgendwie. Hat das Rating behindert-->
          <!--<a class="carousel-control-prev pointer-click" v-on:click="page&#45;&#45;" v-if="page > 1" role="button">-->
          <!--<span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
          <!--<span class="sr-only">Previous</span>-->
          <!--</a>-->
          <!--<a class="carousel-control-next pointer-click" v-on:click="page++" v-if="page < numPages" role="button">-->
          <!--<span class="carousel-control-next-icon" aria-hidden="true"></span>-->
          <!--<span class="sr-only">Next</span>-->
          <!--</a>-->
        </div>
      </div>
      <div class="laser-overlay" v-if="setting.laserpointer === true" @click="placeLaserPointer($event)">
        <div
            class="laser-point"
            v-if="laserPosition"
            :style="{ top: laserPosition.y + 'px', left: laserPosition.x + 'px' }"
        ></div>
      </div>

    </div>
    <loader v-else></loader>
    <div class="offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1"
         id="offcanvasComments" aria-labelledby="offcanvasScrollingLabel">
      <div class="offcanvas-header">
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <Comment :poster_id="poster.id" v-if="poster && poster.id && setting.comment === true"
                 v-on:commentCount="showCommentCount"></Comment>
      </div>
    </div>
    <div class="offcanvas offcanvas-start bg-primary" tabindex="-1" id="offcanvasAction"
         aria-labelledby="staticBackdropLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="staticBackdropLabel">{{ _.poster_nav_actions }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <div>
          <router-link class="btn d-flex" :to="'/viewer/abstract/' + poster.abstract_id"
                       v-if="setting.abstract === true"
                       title="Switch to abstract">
            <icon :icon="['fab', 'wpforms']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Abstract</span>
          </router-link>
          <router-link class="btn d-flex mt-3" :to="'/viewer/video/' + poster.abstract_id"
                       v-if="poster.content.video"
                       title="Switch to abstract">
            <icon :icon="['fal', 'film']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Video</span>
          </router-link>
          <a class="btn d-flex mt-3" target="_blank" :href="getPDFUrl('poster')" v-if="setting.download === true">
            <icon :icon="['fal', 'file-download']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Download</span>
          </a>
          <button class="btn  d-flex mt-3" v-if="setting.comment === true" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasComments"
                  aria-controls="offcanvasComments">
            <icon :icon="['fal', 'comments']" class="fa-3x"/>
            <span class="my-auto">&nbsp;Comments</span>
          </button>
          <button class="btn d-flex mt-3" v-if="setting.contact === true"
                  v-on:click="openContact(poster.abstract_id)">
            <icon :icon="['fal', 'message']" class="fa-3x"/>
            <span class="my-auto">&nbsp;{{ _.card_contact }}</span>
          </button>
          <button class="btn btn-outline-primary text-white mt-auto d-flex" data-bs-dismiss="offcanvas">
            <icon :icon="['fal', 'xmark']" class="fa-3x"/>
            <span class="my-auto">&nbsp;{{ _.buttons_close }}</span>
          </button>
        </div>
      </div>
    </div>
    <div ref="" class="modal fade" id="staticBackdropRating" data-bs-backdrop="static" data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="staticBackdropRatingLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h1 class="modal-title fs-5 " id="staticBackdropRatingLabel">Rating</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <rating :poster="poster.id" v-on:ratingSaved="closeRatingModal()"></rating>
          </div>
          <div class="modal-footer">
            <button ref="ratingCloseButton" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div ref="" class="modal fade" id="staticBackdropDownload" data-bs-backdrop="static" data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="staticBackdropDownloadLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h1 class="modal-title fs-5 " id="staticBackdropDownloadLabel">Download</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body d-flex">
            <div>Please scan the code with your device</div>
            <qrcode class="mx-auto" :value="getPDFUrl($route.name)" :options="{ width: 200 }"></qrcode>
          </div>
          <div class="modal-footer">
            <button ref="downloadCloseButton" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
import Rating from "../components/Rating";
import axios from 'axios'
import Loader from '../components/Loader';
import Comment from "@/views/Comment";
import pdfvuer from 'pdfvuer'
import AudioPlayer from "../components/AudioPlayer";
import {Modal} from "bootstrap";
import Timer from "@/views/Timer.vue";

export default {
  name: "ViewerPDF",
  components: {Timer, AudioPlayer, Comment, Rating, Loader, pdf: pdfvuer},
  computed: {
    ...mapState(['fullscreen', 'poster', 'setting', 'selectedView']),
    ...mapGetters([
      'filteredPosters',
    ]),
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 1,
      rotate: 0,
      scale: 'page-width',
      pdfdata: undefined,
      commentCount: 0,
      laserPosition: null, // Position des Laserpunkts
    }
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    ...mapMutations(['setContactPoster']),
    setScale(newScale) {
      this.scale = newScale;
    },
    getPosition() {
      let index = this.filteredPosters.findIndex(object => {
        return object.abstract_id === parseInt(this.$route.params.id);
      });
      return index;
    },
    getClasses() {
      let code = 'col col-xl-7 offset-xl-2 col-12 border overflow-auto';
      if (this.$store.state.fullscreen === true) {
        code = 'col border overflow-auto';
      }
      return code;
    },
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
        let self = this;
        self.pdfdata = pdfvuer.createLoadingTask(this.getPDFUrl(this.$route.name));
        self.pdfdata.then(pdf => {
          self.numPages = pdf.numPages;
        });
      }).catch((error) => {
      })
    },
    getPDFUrl(target) {
      let src = '';
      if (!this.poster || !this.poster.content) {
        return src;
      }
      if (target === 'poster') {
        src = this.poster.content.poster;
      } else if (target === 'additional_paper') {
        src = this.poster.content.additional_paper;
      }
      return process.env.VUE_APP_PATH_S3URL + src;
    },
    getAudioUrl(src) {
      return process.env.VUE_APP_PATH_S3OLDURL + src;
    },
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    showVideo(video) {
      this.$store.state.presentationSite = this.page;
      this.$router.push('/viewer/video/' + video);
    },
    keyPressed: function (event) {
      if ((event.which === 37 || event.which === 33) && this.page > 1) {
        this.page--;
      }
      if ((event.which === 39 || event.which === 34) && this.page < this.numPages) {
        this.page++;
      }
    },
    forceFileDownload(response) {
      this.$store.dispatch('TRACK_ACTION', {
        'value': this.$route.params.id,
        'action': 'download/pdf',
        'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', process.env.VUE_APP_PATH_S3URL + this.$store.state.poster.content.poster);
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(src) {
      axios({
        method: 'get',
        url: this.getPDFUrl(src),
        responseType: 'arraybuffer'
      })
          .then(response => {
            this.forceFileDownload(response)
          })
          .catch(() => alert('error occured'))
    },
    error: function (err) {
    },
    openContact(poster_id) {
      this.setContactPoster(this.$route.params.id);
      let modal = new Modal(document.getElementById('modalContact'));
      modal.show();
    },
    showCommentCount(counter) {
      this.commentCount = counter;
    },
    // Platziert den Laserpunkt an der Touch-/Klickposition
    placeLaserPointer(event) {

      const rect = event.currentTarget.getBoundingClientRect();
      this.laserPosition = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top + 100,
      };
      // Optional: Laserpunkt nach einer Zeit wieder ausblenden
      setTimeout(() => {
        this.laserPosition = null;
      }, 1000); // z. B. nach 1 Sekunde
    },
  },
  beforeRouteLeave(to, from, next) {
    this.page = 1;
    next();
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  created() {
    this.$store.dispatch('TRACK_ACTION', {
      'value': this.$route.params.id,
      'action': 'viewer/pdf',
      'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
    });
    window.addEventListener('keyup', this.keyPressed);
    this.getPdf();
    if (this.$store.state.presentationSite > 0) {
      this.page = this.$store.state.presentationSite;
    }
  }
}
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
